import { AppstoreOutlined } from "@ant-design/icons";

import { SectionGroupButtonProps } from "../../../../shared/components/SectionGroupButtons/components";
import { InsurancePolicyListGroupButtons } from "../interfaces";
import { AlertsForProducersWeb } from "../../../../shared/interfaces";
import { EMPTY_TEXT } from "../../../../shared/utils";
import { QUICKFILTER } from "../../../../shared/interfaces/enums/quick-filter-enum";

export const getAlertsButtons = ({
    proximasAVencer,
    pendientesRenovacionPorSaldo,
    vencidasNoRenovadas,
    vidaLctSinActualizar,
    vidaColectivoSinActualizar,
    reversionUltimoEndoso,
    solicitudDeArrepentimiento,
    endososAumentoAutos,
    endososAumentoAscensoresCalderas,
}: AlertsForProducersWeb): Array<SectionGroupButtonProps>  => [
    {   
        id: InsurancePolicyListGroupButtons.POLICIES_SOON_TO_EXPIRE,
        iconName: <AppstoreOutlined />,
        title: proximasAVencer ? String(proximasAVencer) : EMPTY_TEXT,
        subTitle: `Próximas a Vencer en los próximos ${QUICKFILTER.MAX_RANGE} dias`,
        disabled: proximasAVencer < 1,
    },
    {
        id: InsurancePolicyListGroupButtons.EXPIRED_AND_NOT_RENEWED,
        iconName: <AppstoreOutlined />,
        title: vencidasNoRenovadas ? String(vencidasNoRenovadas) : EMPTY_TEXT,
        subTitle: 'Vencidas y no renovadas',
        disabled: vencidasNoRenovadas < 1,
    },
    {
        id: InsurancePolicyListGroupButtons.GROUP_LIFE_LCT,
        iconName: <AppstoreOutlined />,
        title: vidaLctSinActualizar ? String(vidaLctSinActualizar) : EMPTY_TEXT,
        subTitle: 'Vida Colectivo LCT',
        disabled: vidaLctSinActualizar < 1,
    },
    {
        id: InsurancePolicyListGroupButtons.GROUP_LIFE_NOT_UPDATED,
        iconName: <AppstoreOutlined />,
        title: vidaColectivoSinActualizar ? String(vidaColectivoSinActualizar) : EMPTY_TEXT,
        subTitle: 'Vida Colectivo Sin Actualizar',
        disabled: vidaColectivoSinActualizar < 1,
    },
    {
        id: InsurancePolicyListGroupButtons.PENDING_RENEWAL_DUE_TO_BALANCE,
        iconName: <AppstoreOutlined />,
        title: pendientesRenovacionPorSaldo ? String(pendientesRenovacionPorSaldo) : EMPTY_TEXT,
        subTitle: 'Pendientes de Renovación Por Saldo',
        disabled: pendientesRenovacionPorSaldo < 1,
    },
    {
        id: InsurancePolicyListGroupButtons.LAST_ENDORSEMENT_REVERSAL,
        iconName: <AppstoreOutlined />,
        title: reversionUltimoEndoso ? String(reversionUltimoEndoso) : EMPTY_TEXT,
        subTitle: 'Reversión ultimo endoso',
        disabled: reversionUltimoEndoso < 1,
    },
    {
        id: InsurancePolicyListGroupButtons.WITHDRAWAL_REQUESTS,
        iconName: <AppstoreOutlined />,
        title: solicitudDeArrepentimiento ? String(solicitudDeArrepentimiento) : EMPTY_TEXT,
        subTitle: 'Solicitudes de arrepentimiento',
        disabled: solicitudDeArrepentimiento < 1,
    },
    {   
        id: InsurancePolicyListGroupButtons.ENDORSEMENTS_INCREASE_AUTOS,
        iconName: <AppstoreOutlined />,
        title: endososAumentoAutos ? String(endososAumentoAutos) : EMPTY_TEXT,
        subTitle: 'Endosos Aumento Autos',
        disabled: endososAumentoAutos < 1,
    },
    {   
        id: InsurancePolicyListGroupButtons.ENDORSEMENTS_INCREASE_ELEVATORS_BOILERS,
        iconName: <AppstoreOutlined />,
        title: endososAumentoAscensoresCalderas ? String(endososAumentoAscensoresCalderas) : EMPTY_TEXT,
        subTitle: 'Endosos Aumento Ascensores y Calderas',
        disabled: endososAumentoAscensoresCalderas < 1,
    },
];